var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("j-title-header", { attrs: { options: _vm.opsi } }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.load_first,
              expression: "load_first"
            }
          ]
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "9" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-left" },
                  [
                    _c("jImportFlows", {
                      on: { "upload-done": _vm.uploadDone }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "create-flow" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createFlow }
                      },
                      [_vm._v("CREATE FLOW")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-server-table",
            {
              ref: "flowServer",
              staticClass: "jTable",
              attrs: {
                url: _vm.env,
                columns: _vm.columns,
                options: _vm.options
              },
              on: {
                loading: _vm.loading,
                loaded: _vm.loaded,
                "row-click": _vm.rowClick,
                pagination: _vm.removeRowBackground
              },
              scopedSlots: _vm._u([
                {
                  key: "created_date",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("moment")(
                              props.row.created_date,
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  }
                },
                {
                  key: "type_name",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.type === 1 ? "ORDER" : "") +
                          "\n        " +
                          _vm._s(props.row.type === 2 ? "NO ORDER" : "") +
                          "\n        " +
                          _vm._s(props.row.type === 3 ? "MIN" : "") +
                          "\n        " +
                          _vm._s(
                            props.row.minimum_action !== 0
                              ? props.row.minimum_action
                              : ""
                          ) +
                          "\n      "
                      )
                    ])
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.filter(_vm.filter_data)
                        }
                      }
                    },
                    [
                      _c("j-input", {
                        staticClass: "m__r--5",
                        attrs: { placeholder: "search" },
                        model: {
                          value: _vm.filter_data,
                          callback: function($$v) {
                            _vm.filter_data = $$v
                          },
                          expression: "filter_data"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn blue outline",
                          on: {
                            click: function($event) {
                              _vm.filter(_vm.filter_data)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-search bold" }),
                          _vm._v(" Search\n          ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "createFlow",
          staticClass: "mod-form",
          attrs: { centered: "", "no-close-on-esc": "" }
        },
        [
          _c(
            "div",
            { staticClass: "float-to-center p--20" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn blue m__r--20",
                  on: {
                    click: function($event) {
                      _vm.$router.replace("/flow/new")
                    }
                  }
                },
                [_vm._v("\n        Create Flow Default\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue outline",
                  on: {
                    click: function($event) {
                      _vm.$router.replace("/flow/new-by-division")
                    }
                  }
                },
                [_vm._v("\n        Create Flow By Division\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.load_first ? _c("div", [_c("jLoadingTable")], 1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf5a485", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf5a485","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/jFlow.vue
// module id = null
// module chunks = 